import type { ReactNode } from "react";
import type { MarkdownPreviewProps } from "@uiw/react-markdown-preview";
import styles from "../../MarkdownContent.module.scss";

interface ILinkRendererProps {
  resolveMediaUrl: (url: string | undefined) => string | undefined;
}

export function createLinkRenderer({ resolveMediaUrl }: ILinkRendererProps): Pick<NonNullable<MarkdownPreviewProps["components"]>, "a"> {
  return {
    a: (props): ReactNode => {
      const { children, ...anchorBaseProps } = props as React.AnchorHTMLAttributes<HTMLAnchorElement> & {
        node?: {
          children?: Array<{
            type?: string;
            tagName?: string;
            properties?: Record<string, unknown>;
          }>;
        };
      };

      const imageChildNode = anchorBaseProps.node?.children?.find((child) => child.type === "element" && child.tagName === "img");

      if (imageChildNode) {
        const imageSrc = typeof imageChildNode.properties?.src === "string" ? imageChildNode.properties.src : undefined;
        const imageAlt = typeof imageChildNode.properties?.alt === "string" ? imageChildNode.properties.alt : "image";
        const resolvedSrc = resolveMediaUrl(imageSrc);
        const { node: _node, ...anchorProps } = anchorBaseProps;

        return (
          <a {...anchorProps}>
            <img src={resolvedSrc} alt={imageAlt} className={styles.linkedImage} />
          </a>
        );
      }

      const { node: _node, ...anchorProps } = anchorBaseProps;
      return <a {...anchorProps}>{children}</a>;
    },
  };
}

